import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Core from './Core';
import Customer from './Customer';
import Customs from './Customs';

const PackingListForm = forwardRef(({list, order = null, fields = 'core', onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const getFields = useCallback(() => {
    switch (fields) {
      case 'customs':
        return Customs;
      case 'customer':
        return Customer;
      case 'core':
      default:
        return Core;
    }
  }, [fields]);

  return (
    <BaseForm
      ref={formRef}
      entity={list}
      type="list"
      fieldsComponent={useCallback((props) => {
        const Fields = getFields();
        return <Fields {...props}/>
      }, [getFields])}
      onSave={useCallback((data) => (
        services.packingList.saveList({
          ...(list?.id ? {id: list.id} : {}),
          ...(order?.id ? {order_id: order.id} : {}),
          ...getFields().onSave(data)
        })
      ), [list, order, services, getFields])}
      onSaved={onSaved}
    />
  );
});

export default PackingListForm;
